import { FunctionComponent, useEffect, useState } from "react"
import React from "react"
import { Button, Card, Col, Divider, Form, Input, notification, Row, Space, Spin } from "antd"
import { SourcesService } from "../api/services.gen"
import { SourceDto } from "../api"

interface SourcesPageProps {
}

const SourcesPage: FunctionComponent<SourcesPageProps> = (props) => {
  const [loading, setLoading] = useState<boolean>(true)
  const [sources, setSources] = useState<SourceDto[]>([])

  const fetchSources = async () => {
    setLoading(true)
    try {
      const response = await SourcesService.listSources()
      setSources(response.sources)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchSources()
  }, [])

  if (loading) {
    return <>
      <h2>Sources</h2>
      <Space>
        <Spin />
      </Space>
    </>
  }
  
  return <>
    <h2>Sources</h2>
    <Space>
      <Col>
        <Row gutter={[16, 16]}>
          {
            sources.length === 0 ? <p>No source</p> : sources?.map(source => <Col><Card title={source.name} key={source.name}>
              { source.link ? <a href={source.link} target="_blank">{new URL(source.link).hostname}</a> : <span>no link</span> }
            </Card></Col>)
          }
        </Row>
      </Col>
    </Space>
  </>
}


export { SourcesPage }